import { ChangeEvent, MutableRefObject } from 'react'
import Sync from '@mui/icons-material/Sync'
import Button from 'components/Shared/Button/Button'
import SydButtonList from 'components/Shared/SydButtonList/SydButtonList'
import { TStringOrNumber } from 'models/shared.models'
import './styles.scss'
import NewInvoiceOption from '../../NewInvoiceOption/NewInvoiceOption'

interface IInvoicesActionsProps {
  uploadInputRef: MutableRefObject<HTMLInputElement | null>
  uploadInputZipRef: MutableRefObject<HTMLInputElement | null>
  handleNewCFDIButton: (value: TStringOrNumber) => false | void | null
  handleXMLFilesSelection: (event: ChangeEvent<HTMLInputElement>) => void
  handleZIPSelection: (event: ChangeEvent<HTMLInputElement>) => void
  toggleSyncDialog: () => void
}

const InvoicesActions = ({
  uploadInputRef,
  uploadInputZipRef,
  handleNewCFDIButton,
  handleXMLFilesSelection,
  handleZIPSelection,
  toggleSyncDialog,
}: IInvoicesActionsProps) => {
  return (
    <article className="invoices-actions">
      <Button
        id="openSyncCfdisDialog"
        variant="outlined"
        color="secondary"
        startIcon={<Sync />}
        onClick={toggleSyncDialog}>
        Sincronizar
      </Button>
      <SydButtonList
        label="Nuevo CFDI"
        options={[
          { 
            id: 0, 
            value: 0, 
            label: <NewInvoiceOption type='new' label='Crear CFDI' description='Crear un nuevo CFDI'/> 
          },
          { 
            id: 1, 
            value: 1, 
            label: <NewInvoiceOption type='xml' label='Cargar XML' description='Carga hasta 50 CFDIs individuales'/> 
          },
          { 
            id: 2, 
            value: 2, 
            label: <NewInvoiceOption type='zip' label='Cargar ZIP' description='Carga tus CFDIs en un archivo ZIP'/> 
          }
        ]}
        handleClickedOption={handleNewCFDIButton}
        menuDirection="bottom"
        drawerStyle="primary"
      />
      <input
        type="file"
        id="file"
        accept=".xml"
        ref={uploadInputRef}
        style={{ display: 'none' }}
        multiple
        onChange={handleXMLFilesSelection}
      />     
      <input
        type="file"
        id="file-zip"
        accept=".zip"
        ref={uploadInputZipRef}
        style={{ display: 'none' }}
        multiple={false}
        onChange={handleZIPSelection}
      />    
    </article>
  )
}

export default InvoicesActions
